import classNames from 'classnames';
import { SelectHTMLAttributes } from 'react';

export function DebugSelect(props: SelectHTMLAttributes<HTMLSelectElement>) {
  return (
    <select {...props} className={classNames('text-black bg-white px-2 py-1.5 rounded-md', props.className)} />
  )
}
